<template>
  <div>
    <div class="types">
      <h2>Types</h2>
      <h3 class="mt-font--body20">Error</h3>
      <div class="mt--text-right">
        <mt-button type="secondary-gray" @click="notiFlag('error')">Open Error Flag</mt-button>
      </div>
      <h3 class="mt-font--body20">Warning</h3>
      <div class="mt--text-right">
        <mt-button type="secondary-gray" @click="notiFlag('warning')">Open Warning Flag</mt-button>
      </div>
      <h3 class="mt-font--body20">Success</h3>
      <div class="mt--text-right">
        <mt-button type="secondary-gray" @click="notiFlag('success')">Open Success Flag</mt-button>
      </div>
      <h3 class="mt-font--body20">Information</h3>
      <div class="mt--text-right">
        <mt-button type="secondary-gray" @click="notiFlag('info')">Open Information Flag</mt-button>
      </div>
      <h3 class="mt-font--body20">Auto Close (3s)</h3>
      <div class="mt--text-right">
        <mt-button type="secondary-gray" @click="notiFlagAutoClose()">Open Information Flag</mt-button>
      </div>
      <h3 class="mt-font--body20">Close Callback</h3>
      <div class="mt--text-right">
        <mt-button type="secondary-gray" @click="callbackClose">Open Flag, Close Callback</mt-button>
      </div>


      <div class="style">
        <h2>Style</h2>
        <h3>Colors</h3>
        <div class="left mt--bg--neutrals-light-gray-01 height250">
          <img :src="notiFlagColorsError" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Bar: #F44336</p>
          <p>Border: #B2C0D0</p>
          <p>Icon: #F44336, #485464  opacity 80%</p>
          <p>Text: #485464</p>
          <p>Subtitle: #718091</p>
        </div>
        <div class="mt--clearfix"></div>
        <div class="left mt--bg--neutrals-light-gray-01 height250">
          <img :src="notiFlagColorsWarning" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Bar: #FFC107</p>
          <p>Border: #B2C0D0</p>
          <p>Icon: #FFC107, #485464  opacity 80%</p>
          <p>Text: #485464</p>
          <p>Subtitle: #718091</p>
        </div>
        <div class="mt--clearfix"></div>
        <div class="left mt--bg--neutrals-light-gray-01 height250">
          <img :src="notiFlagColorsSuccess" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Bar: #00C853</p>
          <p>Border: #B2C0D0</p>
          <p>Icon: #00C853, #485464  opacity 80%</p>
          <p>Text: #485464</p>
          <p>Subtitle: #718091</p>
        </div>
        <div class="mt--clearfix"></div>
        <div class="left mt--bg--neutrals-light-gray-01 height250">
          <img :src="notiFlagColorsInformation" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Bar: #7364FF</p>
          <p>Border: #B2C0D0</p>
          <p>Icon: #7364FF, #485464  opacity 80%</p>
          <p>Text: #485464</p>
          <p>Subtitle: #718091</p>
        </div>
        <div class="mt--clearfix"></div>
        <h3>Sizing</h3>
        <div class="left mt--bg--neutrals-light-gray-01 height250">
          <img :src="sizing" alt="">
        </div>
        <div class="right mt-font--body10 height198">
          <p>Corner radius: 2px</p>
          <p>Width: auto</p>
          <p>Minimum width: 350px</p>
          <p>Height: 120px</p>
          <p>Border: 0.5px</p>
          <p>Font size: 16px</p>
          <p>Line height: 24px</p>
          <p>Font size(subtitle): 14px</p>
          <p>Line height(subtitle): 22px</p>
        </div>

        <h3>Position</h3>
        <div class="left mt--bg--neutrals-light-gray-01 imgbox">
          <img :src="position" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Corner radius: 2px</p>
          <p>Width: auto</p>
          <p>Minimum width: 350px</p>
          <p>Height: 120px</p>
          <p>Border: 0.5px</p>
          <p>Font size: 16px</p>
          <p>Line height: 24px</p>
          <p>Font size(subtitle): 14px</p>
          <p>Line height(subtitle): 22px</p>
        </div>

      </div><!-- //.style -->


    </div><!--//.types-->
  </div>
</template>

<script>
export default {
  name: 'notificationFlag',
  props: [],
  components: {

  },
  data () {
    return {
      notiFlagColorsError: require('@/assets/notification-flag-error-color.svg'),
      notiFlagColorsWarning: require('@/assets/notification-flag-warning-color.svg'),
      notiFlagColorsSuccess: require('@/assets/notification-flag-success-color.svg'),
      notiFlagColorsInformation: require('@/assets/notification-flag-information-color.svg'),
      sizing: require('@/assets/notification-flag-sizing.svg'),
      position: require('@/assets/notification-flag-position.svg'),
    }
  },
  computed: {

  },

  methods: {
    notiFlag(type){
      this.$mtNotiFlag('title', 'subTitle', {type: type})
    },
    notiFlagAutoClose(){
      this.$mtNotiFlag('title', 'subTitle', {type: 'info', autoClose: true})
    },
    callbackClose(){
      this.$mtNotiFlag('title', 'subTitle', {type: 'success', onClose: () =>{
        this.warningConfirm()
      }})
    },
    warningConfirm() {
      this.$mtConfirm(`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard`, 'Title', {
        confirmButtonText: 'Small button',
        cancelButtonText: 'Subtle',
        type: 'warning'
      })
      .then((res) => {
        //confirm
      })
      .catch(() => {
        //cancel
      })
    },
  },
}
</script>

<style lang="scss" scoped>
h3 { font-weight: normal; }
h3.sizing { margin-top: 110px}
h3.sizing, h3.colors { margin-bottom:27px}
p {
  line-height: 1.57;
  margin: 0;
}
.types .mt-noti-flag {
  width: 600px;
  float: right;
  margin-bottom: 39px;
}
.styles .mt-noti-flag {
  margin: 0 auto;
  width: 78%;
}
.right {
  width: 250px;
  padding: 2%;
  float: left;
  .button-wrap{
    padding-right: 20px;
  }
}
.left{
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 600px;
  float: left;
  position: relative;
  margin-bottom: 2em;
  &.height250 { height: 250px; }
  &.imgbox {
    display: block;
    img { width: 100%; }
  }
}
</style>




// WEBPACK FOOTER //
// NotificationFlag.vue?9a0e0024